import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { ScrollToTop } from './components/ScrollToTop';
import { AlertBar } from './components/AlertBar';
import { Footer } from './components/Footer';
import { BackToTop } from './components/BackToTop';
import { DebugBar } from './components/DebugBar';
import { LanguageProvider } from './contexts/LanguageContext';
import { TextSizeProvider } from './contexts/TextSizeContext';
import { AuthProvider } from './contexts/AuthContext';
import { DebugProvider } from './contexts/DebugContext';
import { RequestsProvider } from './contexts/RequestsContext';
import { PermitsProvider } from './contexts/PermitsContext';
import { RequireAuth } from './components/auth/RequireAuth';
import { EspaceProvider } from './contexts/EspaceContext';
import { EspaceLayout } from './components/espace/EspaceLayout';
import { Accueil } from './pages/Accueil';
import { MaCarte } from './pages/MaCarte';
import { MesCollectes } from './pages/MesCollectes';
import { CalendrierCollectes } from './pages/CalendrierCollectes';
import { MonProfil } from './pages/MonProfil';
import { MesLoisirs } from './pages/MesLoisirs';
import { AvisNotifications } from './pages/AvisNotifications';
import { ParametresAvis } from './pages/ParametresAvis';
import { MesDemandes } from './pages/MesDemandes';
import { DemandeDetail } from './pages/DemandeDetail';
import { DemandeFormulaire } from './pages/DemandeFormulaire';
import { MesPermis } from './pages/MesPermis';
import { PermisDetail } from './pages/PermisDetail';
import { PermisFormulaire } from './pages/PermisFormulaire';
import { MonEspace } from './pages/MonEspace';
import { MesAnimaux } from './pages/MesAnimaux';
import { Plan } from './pages/Plan';
import { AnimalDetail } from './pages/AnimalDetail';
interface AppProps {
  showAlertBar?: boolean;
  showEvents?: boolean;
}
export function App({
  showAlertBar = true,
  showEvents = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="36hw15qrsq0p">
      <LanguageProvider data-id="element-1" data-mp="35yn2ej3lbyt">
        <TextSizeProvider data-id="element-2" data-mp="356s95xbri9l">
        <AuthProvider data-id="element-3" data-mp="38kxqn1ac7l9">
          <DebugProvider data-id="element-4" data-mp="3uct3bjmdin0h">
          <RequestsProvider data-id="element-5" data-mp="3udkoe0ich2ci">
          <PermitsProvider data-id="element-6" data-mp="3uc9jtyh2rqkc">
          <EspaceProvider data-id="element-7" data-mp="3uf5ixq4nslad">
          <div id="accueil" className="min-h-screen w-full bg-white" data-id="element-8" data-mp="d4e5lt427cwp">
            <ScrollToTop data-id="element-9" data-mp="d2l6cyvrzuyq" />
            <div className="sticky top-0 z-40" data-id="element-10" data-mp="85ukfuxai55e">
              <Header data-id="element-11" data-mp="8649ngaig8a1" />
              {showAlertBar && <AlertBar data-id="element-12" data-mp="3gleakl2nz7g8" />}
            </div>
            <EspaceLayout data-id="element-13" data-mp="3gm665vw9h56i">
              <Routes data-id="element-14" data-mp="3gja6o34rm8fy">
                <Route path="/" element={<Accueil showEvents={showEvents} data-id="element-16" data-mp="3bn2ye3owckuu" />} data-id="element-15" data-mp="3bmbalf1jjrf4" />
                <Route path="/plan" element={<Plan data-id="element-18" data-mp="3qaxulu2457co" />} data-id="element-17" data-mp="3bk736n4foaa3" />
                <Route path="/ma-carte" element={<RequireAuth label="Ma carte numérique" data-id="element-20" data-mp="3lk7k62etyeb4">
                      <MaCarte data-id="element-21" data-mp="2xuwubfz0q4br" />
                    </RequireAuth>} data-id="element-19" data-mp="3qc94mbm5jbc8" />
                <Route path="/mes-collectes" element={<RequireAuth label="Mes collectes" data-id="element-23" data-mp="2stzaz029v48o">
                      <MesCollectes data-id="element-24" data-mp="18cznek02jfn0" />
                    </RequireAuth>} data-id="element-22" data-mp="2svtohtb7ru2q" />
                <Route path="/mes-collectes/calendrier" element={<RequireAuth label="Le calendrier des collectes" data-id="element-26" data-mp="yh6a2yeizi46">
                      <CalendrierCollectes data-id="element-27" data-mp="13fq0pc42di2v" />
                    </RequireAuth>} data-id="element-25" data-mp="1d62jaysbj16d" />
                <Route path="/mon-profil" element={<RequireAuth label="Mon profil" data-id="element-29" data-mp="1w2as2ckjhu6f">
                      <MonProfil data-id="element-30" data-mp="1i3kukvtt5shj" />
                    </RequireAuth>} data-id="element-28" data-mp="1r5katlx00sjf" />
                <Route path="/mes-loisirs" element={<RequireAuth label="Mes loisirs" data-id="element-32" data-mp="1m70lrcn3z0mu">
                      <MesLoisirs data-id="element-33" data-mp="6nmguenoqi9z" />
                    </RequireAuth>} data-id="element-31" data-mp="1m560fx7xd6i8" />
                <Route path="/notifications" element={<AvisNotifications data-id="element-35" data-mp="ano95x7j5zcl" />} data-id="element-34" data-mp="aqslxiz2a3ev" />
                <Route path="/notifications/parametres" element={<RequireAuth label="Mes préférences de communication" data-id="element-37" data-mp="m5dyqdderswh">
                      <ParametresAvis data-id="element-38" data-mp="h6sxqbqc156z" />
                    </RequireAuth>} data-id="element-36" data-mp="qxfbe0ehnln1" />
                <Route path="/mes-demandes" element={<RequireAuth label="Mes demandes" data-id="element-40" data-mp="19wjd0o3pad4o">
                      <MesDemandes data-id="element-41" data-mp="19tx7eu0de7p3" />
                    </RequireAuth>} data-id="element-39" data-mp="c90uwmo5fyo0" />
                <Route path="/mes-demandes/nouvelle" element={<RequireAuth label="Mes demandes" data-id="element-43" data-mp="zzoi0f6myuv5">
                      <DemandeFormulaire data-id="element-44" data-mp="vv71qpzhizp4" />
                    </RequireAuth>} data-id="element-42" data-mp="14uu4pg7v4dka" />
                <Route path="/mes-demandes/:id" element={<RequireAuth label="Mes demandes" data-id="element-46" data-mp="3glo5xw36zmzn">
                      <DemandeDetail data-id="element-47" data-mp="1w4ov8gm37sve" />
                    </RequireAuth>} data-id="element-45" data-mp="3kpm8yhvn1hxz" />
                <Route path="/mes-permis" element={<RequireAuth label="Mes permis" data-id="element-49" data-mp="255d6x4o0dh54">
                      <MesPermis data-id="element-50" data-mp="253sdxjhce69d" />
                    </RequireAuth>} data-id="element-48" data-mp="205igt3c24vl4" />
                <Route path="/mes-permis/formulaire" element={<RequireAuth label="Mes permis" data-id="element-52" data-mp="2eun2wvlz3jyi">
                      <PermisFormulaire data-id="element-53" data-mp="2jt834v1863my" />
                    </RequireAuth>} data-id="element-51" data-mp="29x4quwcnsoma" />
                <Route path="/mes-permis/:id" element={<RequireAuth label="Mes permis" data-id="element-55" data-mp="2suxq9oo2qgex">
                      <PermisDetail data-id="element-56" data-mp="2ssbknukquazc" />
                    </RequireAuth>} data-id="element-54" data-mp="2nwnwnihzznvf" />
                <Route path="/mon-espace" element={<RequireAuth label="Mon espace citoyen" data-id="element-58" data-mp="yihpv4hylwhz">
                      <MonEspace data-id="element-59" data-mp="21sdf6457xrh8" />
                    </RequireAuth>} data-id="element-57" data-mp="ygoh9jnsd27c" />
                <Route path="/mes-animaux" element={<RequireAuth label="Mes animaux" data-id="element-61" data-mp="2at1ud26clxvp">
                      <MesAnimaux data-id="element-62" data-mp="25t5rx7dauei9" />
                    </RequireAuth>} data-id="element-60" data-mp="1wu24jr73ncxy" />
                <Route path="/mes-animaux/:id" element={<RequireAuth label="Mes animaux" data-id="element-64" data-mp="2frlgb2kxz9o2">
                      <AnimalDetail data-id="element-65" data-mp="2fqtugjh5cqaz" />
                    </RequireAuth>} data-id="element-63" data-mp="2kq6jnavhq9gq" />
                <Route path="*" element={<Accueil showEvents={showEvents} data-id="element-67" data-mp="2tkkyjcc3zhzb" />} data-id="element-66" data-mp="2thymp0i6qgba" />
              </Routes>
            </EspaceLayout>
            <Footer data-id="element-68" data-mp="33gxnjwwpl7nq" />
            <BackToTop data-id="element-69" data-mp="33gehbdgf87pj" />
            <DebugBar data-id="element-70" data-mp="33hpj57qb35e0" />
          </div>
          </EspaceProvider>
          </PermitsProvider>
          </RequestsProvider>
          </DebugProvider>
        </AuthProvider>
        </TextSizeProvider>
      </LanguageProvider>
    </BrowserRouter>;
}